import React, { useEffect, useState } from "react";
import crown from "../../assets/crown.png";
import star from "../../assets/starBig.png";
import arrowSmall from "../../assets/arrowSmall.png";
import { getUserDetails } from "../../services/api";
import { useAddress } from "@thirdweb-dev/react";

const LeaderBoard = ({ className, setNav }) => {
    console.log("%c Line:9 🌶 props", "color:#6ec1c2", setNav);
    const address = useAddress();
    const [userDetailsData, setUserDetailsDa] = useState("");

    const fetchData = async (address) => {
        try {
            const data = await getUserDetails(address);
            if (data) {
                setUserDetailsDa(data);
                console.log("%c Line:16 🍑 data", "color:#93c0a4", data);
            }
        } catch (error) {
            console.log("%c Line:13 🎂 error", "color:#ea7e5c", error);
        }
    };

    useEffect(() => {
        if (address) {
            fetchData(address);
        }
    }, [address]);

    return (
        <div className={className}>
            <h4 className="font-extrabold text-[30px] lg:text-[36px] leading-[44px] xl:leading-[48px] text-white">
                Your <span className="text-[#FE61BD]">Score</span>
            </h4>
            <p className="font-medium text-[16px] lg:text-[18px] leading-[26px] xl:leading-[30px] text-[#ababab] mt-4 text-left">
                Conquer the leaderboard by completing more & more tasks and earn
                XP as quickest as possible.
            </p>
            <div className=" border border-[#77777780] rounded-[16px] p-[20px] flex flex-col justify-center items-start w-full mt-6">
                <div className="flex items-start justify-start gap-3">
                    <img
                        src={crown}
                        alt=" "
                        className="size-[40px] lg:size-[48px]"
                    />
                    <p className="text-[26px] lg:text-[32px] font-extrabold text-white">
                        {userDetailsData?.rank ? userDetailsData?.rank : 0}
                    </p>
                </div>
                <p className="text-[18px] lg:text-[20px] font-medium text-[#ababab] mt-2">
                    Leaderboard Rank
                </p>
            </div>
            <div className=" border border-[#77777780] rounded-[16px] p-[20px] flex flex-col justify-center items-start w-full mt-5">
                <div className="flex items-start justify-start gap-3">
                    <img
                        src={star}
                        alt=" "
                        className="size-[40px] lg:size-[48px]"
                    />
                    <p className="text-[26px] lg:text-[32px] font-extrabold text-white">
                        {userDetailsData?.xp ? userDetailsData?.xp : 0}
                    </p>
                </div>
                <p className="text-[18px] lg:text-[20px] font-medium text-[#ababab] mt-2">
                    My XP Points
                </p>
            </div>
            <div
                className="flex items-start justify-center gap-2 mt-6 xl:mt-10"
                onClick={() => {
                    setNav("leaderboard");
                }}
            >
                <p className="fontsemibold text-[20px] lg:text-[24px] text-white">
                    View Leaderboard
                </p>
                <img
                    alt=""
                    src={arrowSmall}
                    className="size-[26px] mt-1 cursor-pointer"
                />
            </div>
        </div>
    );
};

export default LeaderBoard;
